import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { Box } from '@chakra-ui/react';
import {
  GetGroupParams,
  startRenderGroups,
} from '../../../helpers/renderGroups';
import { useMemo } from 'react';
import { HeaderControllerView, HeaderGroupView } from './HeaderGroups';
import { UseGridOperations } from '../../../hooks/useGridOperations';

interface ColumnGroupsProps
  extends ReturnTypeofSheetSectionsSelector,
    Pick<
      UseSheetTheme,
      'stroke' | 'isRtl' | 'fill' | 'secondaryFill' | 'isDarkTheme'
    >,
    Pick<UseGridOperations, 'openContextMenu'> {
  sheetId: string;
  gridWidth: number;
  x: number;
  y: number;
}

const ColumnGroups: React.FC<ColumnGroupsProps> = (props) => {
  const getGroupControlView = (params: GetGroupParams) => (
    <HeaderControllerView
      {...params}
      isColumn={true}
      zoom={props.zoom}
      isRtl={props.isRtl}
      isDarkTheme={props.isDarkTheme}
      key={`${params.group.id}-col-control`}
      openContextMenu={props.openContextMenu}
    />
  );

  const getGroupView = (params: GetGroupParams) => (
    <HeaderGroupView
      {...params}
      isColumn={true}
      zoom={props.zoom}
      isRtl={props.isRtl}
      isDarkTheme={props.isDarkTheme}
      key={`${params.group.id}-col`}
      openContextMenu={props.openContextMenu}
    />
  );

  const Groups = useMemo(() => {
    return startRenderGroups(props, getGroupView, getGroupControlView, true);
  }, [props.colViewport, props.isRtl, props.isDarkTheme]);

  if (props.groupBarHeight === 0) return null;

  return (
    <Box
      top={`${props.y}px`}
      left={`${props.x + props.rowHeaderWidth}px`}
      width={`${props.gridWidth - props.rowHeaderWidth}px`}
      position="relative"
      height={`${props.groupBarHeight}px`}
    >
      {Groups}
    </Box>
  );
};

export default ColumnGroups;
